
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty-and-fraud-statements",
      function () {
        return require("private-next-pages/warranty-and-fraud-statements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warranty-and-fraud-statements"])
      });
    }
  